const component = {
  template: `
    <div class="gbThemedHeading">
      <div class="gbThemedHeading__text" ng-bind-html="$ctrl.text"></div>
    </div>
  `,
  bindings: {
    id: '@',
    text: '@'
  },
};

export default component;



// WEBPACK FOOTER //
// ./js/containers/causePortal/components/gbThemedHeading/index.js